var map = {
	"./classic_0.png": "343d",
	"./classic_1.png": "9167",
	"./classic_2.png": "669f",
	"./classic_3.png": "f690",
	"./classic_4.png": "e3d6",
	"./classic_5.png": "d8bd",
	"./classic_6.png": "cebe",
	"./classic_7.png": "b86c",
	"./classic_8.png": "b91a",
	"./classic_blocked.png": "6dcd",
	"./classic_m0.png": "f42d",
	"./classic_m1.png": "740f",
	"./classic_m2.png": "35ff",
	"./classic_m3.png": "7882",
	"./classic_m4.png": "e0f8",
	"./classic_m5.png": "05df",
	"./classic_m6.png": "5212",
	"./classic_m7.png": "0ec1",
	"./classic_m8.png": "b0d4",
	"./classic_unknown.png": "fe1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "42fc";